document.addEventListener('DOMContentLoaded', function () {
  // Get elements
  const sizeChartTrigger = document.getElementById('size-chart-trigger');
  const sizeChartPopup = document.getElementById('size-chart-popup');
  const popupClose = document.getElementById('popup-close');

  // Show the popup when the trigger is clicked
  if (sizeChartTrigger) {  
    sizeChartTrigger.addEventListener('click', function () {
      sizeChartPopup.style.display = 'block';
    });
  }

  // Close the popup when the close button is clicked
  if (popupClose) {  
    popupClose.addEventListener('click', function () {
      sizeChartPopup.style.display = 'none';
    });
  }

  // Close the popup when clicking outside the content
  if (sizeChartPopup) {  
    sizeChartPopup.addEventListener('click', function (event) {
      if (event.target === sizeChartPopup) {
        sizeChartPopup.style.display = 'none';
      }
    });
  }
});

$(document).ready(function(){
  // Header Mobile Close
  $('#menu-drawer-close').click(function () {
    $('.header__icon--menu')[0].click();
  });
  // Header Mobile Close

  // Main-banner
  if($('.main-banner').length > 0){
    function main_banner_height(){
      var ann_bar = $('.announcement-bar-section').length > 0 ? $('.announcement-bar-section').outerHeight() : 0;
      $('.main-banner').css('--banner-height',($(window).height() - ann_bar + 'px'));
    }
    main_banner_height();
    $(window).on('resize',function(){
      main_banner_height();
    });
  }
  // Main-banner

  // Collection Hover and on mobile Scroll Section
  if($('.collection-hover').length > 0){
    function collectionHover(){
      if ($(window).width() > 749) {
        $('.collection-hover .collection-hover_button').mouseenter(function () {
          $(this).addClass('is-selected').parents('div').siblings().find('.collection-hover_button').removeClass('is-selected');
          var target = $(this).data('target');
          
          $(this).parents('.collection-hover').find('.collection-hover_image[data-id='+ target +']').addClass('is-visible').siblings().removeClass('is-visible');
        });
      }else{
        $('.collection-hover .collection-hover_actions > div').eq(0).find('.collection-hover_button').addClass('is-active');
        $('.collection-hover .collection-hover_images .collection-hover_image').eq(0).addClass('is-visible');
        $(window).on('scroll',function(){
          if ($(window).width() < 750) {
            let current;
            $('.collection-hover .collection-hover_image').each(function(){
              const imageTop = $(this).offset().top;
              const imageHeight = $(this).height();
              if (window.pageYOffset >= imageTop - imageHeight / 3) {
                $(this).addClass('is-visible').siblings().removeClass('is-visible');
                current = $(this).data("id");
              }
            });
            $('.collection-hover .collection-hover_button[data-target='+ current +']').addClass('is-selected').parents('div').siblings().find('.collection-hover_button').removeClass('is-selected');
          }
        });
      }
    }
    collectionHover();
    $(window).resize(function() {
      collectionHover();
    });
  }
  // Collection Hover and on mobile Scroll Section

  // Sticky Image Text Scroll
  if($('.sticky-image-text-scroll .image_text_scroll_body .image_text_scroll_inner .image_text_scroll_row').length > 1){
    $(window).on('scroll',function(){
      var holderTop = $('.sticky-image-text-scroll .image_text_scroll_body')[0].getBoundingClientRect().top + window.scrollY;
      var section_row = $('.sticky-image-text-scroll .image_text_scroll_body .image_text_scroll_inner .image_text_scroll_row').length;
      var section_height = $('.sticky-image-text-scroll .image_text_scroll_wrapper .image_text_scroll_body').outerHeight();
      var block_height = section_height / section_row;
      const windowHeight  = window.innerHeight;
      const scrollY = window.scrollY + 1.5 * windowHeight;
      let scrollPercent = 0;
      if (scrollY >= holderTop && scrollY <= holderTop + section_height + windowHeight) {
            let rowTop = holderTop;
            $('.sticky-image-text-scroll .image_text_scroll_row').each(function(index, row) {
              if (index > 0) {
                    let isSelected = rowTop + block_height < scrollY;
                    row.classList.toggle('is-selected', isSelected);
                }
                rowTop += block_height;
            });
        }
    });
    
    $('.sticky-image-text-scroll .image_text_scroll_row-wrap').on('scroll',function() {
      var parent = $(this);
      var parentScrollLeft = parent.scrollLeft();
      var parentWidth = parent.width();
      
      $('.sticky-image-text-scroll .image_text_scroll_body .image_text_scroll_inner .image_text_scroll_row').each(function(i,t){
        if(i > 0){
          var child = $(this);
          var childOffsetLeft = child.offset().left - parent.offset().left + parentScrollLeft;
          var childWidth = child.outerWidth();

          if (childOffsetLeft + childWidth > parentScrollLeft && childOffsetLeft < parentScrollLeft + parentWidth) {
              child.addClass('is-visible');
          } else {
              child.removeClass('is-visible');
          }
        }
      });
    });
  }
  // Sticky Image Text Scroll
  
  // Faq Section
  if($('.section-faq').length > 0){
    $('.section-faq .section-faq-wrap .faq-block .faq-question').click(function(){
      $(this).parent('.faq-block').toggleClass('active');
      $(this).next('.faq-answer').slideToggle();
    });
  }
  // Faq Section


  // Sort Popup
  if($('.sort_by-popup').length > 0){
    $(document).on('click','.sort_by-popup #sort_by-popup-btn',function (e) {
      e.preventDefault();
      $(this).parent('.sort_by-popup').toggleClass('open_popup');
    });
    $('body').on('click',function(event){
       if(!$(event.target).is('.sort_by-popup') && !$(event.target).is('#sort_by-popup-btn')){
         $(".sort_by-popup").removeClass("open_popup");
       }
    });
  }
  // Sort Popup


  // Look
  if($('.look .look__dot__button').length > 0){
    $('.look .look__dot__button').click(function() {
      var index = $(this).data('product-target'),
          target = $(this).parents('.look').find('.look_product[data-product-index="'+ index +'"]'),
          section = $(this).parents('.look'),
          header = $('.section-header.shopify-section-header-sticky .header-wrapper').innerHeight(),
          target_top = target[0].getBoundingClientRect().top,
          target_height = target.outerHeight(),
          sec_height = section.outerHeight(),
          sec_top = section[0].getBoundingClientRect().top + window.scrollY,
          j = sec_top + sec_height,
          s = target_height / 2,
          i = window.innerHeight,
          n = i / 2;
      let a = target_top + s - header - n + window.scrollY;
      if(a < sec_top){
         a = sec_top - header
      }else if(a + i > j){
        a = j - i;
      }
      window.scrollTo({top: a,behavior: "smooth"})
    });
  }
  // Look

  // Product Animated Detail Summery
  if($('.accrodian_animate__detail .accrodian_animate__summery').length > 0){
    $(document).on('click','.accrodian_animate__detail .accrodian_animate__summery',function () {
      $(this).parent('.accrodian_animate__detail').toggleClass('open')
      $(this).next('.accrodian_animate__content').slideToggle()
    });
  }
  // Product Animated Detail Summery

  // Cart Drawer pair with
  if($('#cart_products-accrodion .cart_products-accrodion-title').length > 0){
    if($('#cart_products-accrodion .cart-pair-with-product').length <= 0){
        $('#cart_products-accrodion').hide();
      }
    $(document).on("click","#cart_products-accrodion .cart_products-accrodion-title",function () {
      $(this).parent('#cart_products-accrodion').toggleClass('open')
      $(this).next('.cart-pair-with-products-wrap').slideToggle();
    });
    $(document).on("click","#cart_products-accrodion .cart-pair-with-product-close",function () {
      $(this).parents('.cart-pair-with-product').remove();
      if($('#cart_products-accrodion .cart-pair-with-product').length <= 0){
        $('#cart_products-accrodion').hide();
      }
    });
  }
  // Cart Drawer pair with

  // Sticky Image Text Scroll Two
  if($('.sticky-img-txt-scroll-two .img_txt_scroll_body .img_txt_scroll_inner .img_txt_scroll_row').length > 1){
    $(window).on('scroll',function(){
      var holderTop = $('.sticky-img-txt-scroll-two .img_txt_scroll_body')[0].getBoundingClientRect().top + window.scrollY;
      var section_row = $('.sticky-img-txt-scroll-two .img_txt_scroll_body .img_txt_scroll_inner .img_txt_scroll_row').length;
      var section_height = $('.sticky-img-txt-scroll-two .img_txt_scroll_wrapper .img_txt_scroll_body').outerHeight();
      var block_height = section_height / section_row;
      const windowHeight  = window.innerHeight;
      const scrollY = window.scrollY + 1.5 * windowHeight;
      let scrollPercent = 0;
      if (scrollY >= holderTop && scrollY <= holderTop + section_height + windowHeight) {
            let rowTop = holderTop;
            $('.sticky-img-txt-scroll-two .img_txt_scroll_row').each(function(index, row) {
              if (index > 0) {
                    let isSelected = rowTop + block_height < scrollY;
                    row.classList.toggle('is-selected', isSelected);
                }
                rowTop += block_height;
            });
        }
    });
    
  
    $('.sticky-img-txt-scroll-two .img_txt_scroll_row-wrap').on('scroll',function() {
      var parent = $(this);
      var parentScrollLeft = parent.scrollLeft();
      var parentWidth = parent.width();
      $('.sticky-img-txt-scroll-two .img_txt_scroll_body .img_txt_scroll_inner .img_txt_scroll_row').each(function(i,t){
        if(i > 0){
          var child = $(this);
          var childOffsetLeft = child.offset().left - parent.offset().left + parentScrollLeft;
          var childWidth = child.outerWidth();

          if (childOffsetLeft + childWidth > parentScrollLeft && childOffsetLeft < parentScrollLeft + parentWidth) {
              child.addClass('is-visible');
          } else {
              child.removeClass('is-visible');
          }
        }
      });
    });
  }
  // Sticky Image Text Scroll Two

  // Workout Text Hover
  if($('.workout-text-hover').length > 0){
    $('.workout-text-hover .workout-text-hover-titles .workout-text-hover-title').on('mouseenter click',function (e) {
      e.preventDefault();
      var target = $(this).data('target-id');
      $(this).addClass('is-selected').siblings('.workout-text-hover-title').removeClass('is-selected');
      $(this).siblings('.workout-text-hover-media').find('img[data-media-id=media-'+ target +']').addClass('is-selected').siblings().removeClass('is-selected');
      $(this).parents('.workout-text-hover-row').find('.workout-text-hover-texts .workout-text-hover-texts-wrap[data-text-id=text-'+ target +']').addClass('is-selected').siblings().removeClass('is-selected');
    });
  }
  // Workout Text Hover

  // Start your free trial button triger
  $("body").on('click','.same_page_link', function (e) { 
    e.preventDefault();
    var aid = $(this).attr("data-url");
    $('html, body').animate({
      scrollTop: $(".section-packages[data-section="+aid+"]").offset().top - 160
    }, 2000);
  });

  if (window.location.href.indexOf('/?data-url=') > 0) {
    function getUrlVars(){
      var vars = [], hash;
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for(var i = 0; i < hashes.length; i++)       {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    }

    var first = getUrlVars()["data-url"];
    var mydata = first.split("%20");
    var myparavalue = mydata.join(" ");
    myparavalue = myparavalue.replace(/_/g, '&');
    $('html, body').animate({
      scrollTop: $(".section-packages[data-section="+myparavalue+"]").offset().top - 160
    }, 2000);
  }
  // Start your free trial button triger

  if (window.location.href.indexOf('/pages/contact?contact_posted=true#ContactForm') > 0) {
    $('html, body').animate({
      scrollTop: $(".contact-form").offset().top - 50
    }, 2000);
  }


  // infinite-text-scroll
  if($('.infinite-text-scroll').length > 0){
    console.log("infinite working...")
    $('.infinite-text-scroll').each(function(){
      var infinite_text_speed = $(this).data('autoplay');
      if ($(window).width() < 750) {
        infinite_text_speed = $(this).data('mautoplay');
      }
      $(this).find('.infinite-text-scroll-container.marquee').marquee({
        speed: infinite_text_speed*1000,
        gap: 0,
        delayBeforeStart: 1000,
        direction: 'left',
        duplicated: true
      });
    }); 
  }
  // infinite-text-scroll
  
  
  // infinite-text-scroll-two
  if($('.infinite-text-scroll-two').length > 0){
    $('.infinite-text-scroll-two').each(function(){
      var infinite_text_two_speed = $(this).data('autoplay');
      if ($(window).width() < 750) {
        infinite_text_two_speed = $(this).data('mautoplay');
      }
      $(this).find('.infinite-text-scroll-two-container.marquee').marquee({
        gap: 0,
        speed: infinite_text_two_speed*1000,
        delayBeforeStart: 1000,
        direction: 'left',
        duplicated: true
      });
    }); 
  }
  // infinite-text-scroll-two
  
});

jQuery(window).on('load',function(){

  const playButtons = document.querySelectorAll('.video-play-btn');

  playButtons.forEach(function(button) {
      button.addEventListener('click', function() {
          const video = this.previousElementSibling;
          if (video.paused) {
              video.play();
              this.src = 'https://cdn.shopify.com/s/files/1/0890/9294/8281/files/pausecircle.png?v=1721783230';
              this.style.top = '90%';
          } else {
              video.pause(); 
              this.src = 'https://cdn.shopify.com/s/files/1/0890/9294/8281/files/playcircle.png?v=1721783513';
              this.style.top = '50%';
          }
      });
  });

  const shadowHost = document.querySelector('recharge-subscription-widget');
  const shadowRoot = shadowHost?.shadowRoot;
  let selectedSellingPlanId = null;

  if (shadowRoot) {
    const checked = shadowRoot.querySelector('input[type="radio"][name="rc_plan"]:checked');
    selectedSellingPlanId = checked?.value;
  }


  if (shadowHost) {
    const shadowRoot = shadowHost.shadowRoot;

    if (shadowRoot) {
      const inputElements = shadowRoot.querySelectorAll(".rc-purchase-option__input");

      if (inputElements.length > 0) {
        inputElements.forEach(function(inputElement) {
          inputElement.addEventListener("change", function(e) {
            if (isShadowRootInputChecked('input[value="subscription"]')) {
              $('.price-per-serving-sub').addClass('active');
              $('.price-per-serving-onetime').removeClass('active');
            } else {
              $('.price-per-serving-sub').removeClass('active');
              $('.price-per-serving-onetime').addClass('active');
            }
          });
        });
      }
    }
  }

  function isShadowRootInputChecked(targetSelector) {
  // Find the shadow host
    const shadowHost = document.querySelector('recharge-subscription-widget');
    
    if (!shadowHost) {
        console.error("Shadow host not found: recharge-subscription-widget");
        return false; // Return false if the host is not found
    }

    // Access the shadow root
    const shadowRoot = shadowHost.shadowRoot;

    if (!shadowRoot) {
        console.error("Shadow root not found for the host: recharge-subscription-widget");
        return false; // Return false if the shadow root is not found
    }

    // Find the target input element inside the shadow root
    const inputElement = shadowRoot.querySelector(targetSelector);

    if (!inputElement) {
        console.error(`Input element not found: ${targetSelector}`);
        return false; // Return false if the input element is not found
    }

    // Return the checked state of the input element
    return inputElement.checked;
  }

});

document.addEventListener('DOMContentLoaded', () => {

  const checkRechargeShadow = setInterval(() => {
    const shadowHost = document.querySelector('recharge-subscription-widget');
    const shadowRoot = shadowHost?.shadowRoot;
    let selectedSellingPlanId = null;

    if (shadowRoot) {
      const rcSellingPlans = shadowRoot.querySelector('rc-selling-plans')?.shadowRoot;
      if (rcSellingPlans) {
        const checked = rcSellingPlans.querySelector('input[type="radio"]:checked');
        selectedSellingPlanId = checked?.value;
      }
    }

  }, 250); // check every 250ms
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('product-form').forEach(function (productFormComponent) {
    const form = productFormComponent.querySelector('form[data-type="add-to-cart-form"]');
    const upsellCheckbox = productFormComponent.querySelector('[data-upsell-checkbox]');
    const upsellVariantInput = productFormComponent.querySelector('.upsell-variant-id');
    const upsellSellingPlanInput = productFormComponent.querySelector('.upsell-selling-plan-id');
    const upsellImage = productFormComponent.querySelector('.upsell-image');
    const upsellPrice = productFormComponent.querySelector('.upsell-price');
    const comparePrice = productFormComponent.querySelector('.upsell-compare-price');

    const shadowHost = document.querySelector('recharge-subscription-widget');

    if (!(form instanceof HTMLFormElement)) return;
    if (!upsellCheckbox || !upsellVariantInput) return;

    const updateUpsellPrice = () => {
      const currencySymbol = Shopify.currency?.symbol || '$';
      let basePrice = null;

      if (upsellVariantInput?.tagName === 'SELECT') {
        const selectedOption = upsellVariantInput.options[upsellVariantInput.selectedIndex];
        basePrice = parseFloat(selectedOption?.getAttribute('data-price'));
      } else if (upsellVariantInput?.tagName === 'INPUT') {
        basePrice = parseFloat(upsellVariantInput.getAttribute('data-price'));
      }

      if (isNaN(basePrice)) return;

      let upsellPlans = [];
      let matchedUpsellPlanId = null;
      let selectedInterval = '';

      const shadowHost = document.querySelector('recharge-subscription-widget');

      if (shadowHost?.shadowRoot) {
        const rcSellingPlans = shadowHost.shadowRoot.querySelector('rc-selling-plans')?.shadowRoot;
        const checked = rcSellingPlans?.querySelector('input[type="radio"]:checked');
        const intervalText = checked?.closest('label')?.querySelector('.rc-plans-button__interval')?.textContent?.toLowerCase();

        if (checked?.value === '') {
          // One-time selected
          selectedInterval = '';
          matchedUpsellPlanId = null; // 🛠 Force clear plan
        } else if (intervalText?.includes('30')) {
          selectedInterval = '30';
        } else if (intervalText?.includes('60')) {
          selectedInterval = '60';
        }
      }

      // Re-parse selling plans after selectedInterval is known
      try {
        const upsellPlanScript = document.getElementById('product-page-upsell-selling-plans-json');
        upsellPlans = JSON.parse(upsellPlanScript?.textContent || '[]');
      } catch (e) {
        console.warn('❌ Could not parse upsell plans');
      }

      if (selectedInterval) {
        for (const plan of upsellPlans) {
          const planName = plan.selling_plan_name?.toLowerCase() || '';
          if (planName.includes(selectedInterval)) {
            matchedUpsellPlanId = plan.selling_plan_id;
            break;
          }
        }
      }

      // Reset selling plan input field
      if (upsellSellingPlanInput) {
        upsellSellingPlanInput.value = matchedUpsellPlanId || '';
      }

      // 🧮 Price calculation
      let finalPrice = basePrice;
      let compareAt = null;

      if (matchedUpsellPlanId) {
        finalPrice = basePrice * 0.85;
        compareAt = basePrice;
      } else {
        finalPrice = basePrice;
        compareAt = null;
      }

      // 💸 Update UI elements
      if (upsellPrice) {
        upsellPrice.textContent = `${currencySymbol}${finalPrice.toFixed(2)}`;
      }


      if (comparePrice) {
        if (compareAt) {
          comparePrice.textContent = `${currencySymbol}${compareAt.toFixed(2)}`;
          comparePrice.style.display = 'inline';
        } else {
          comparePrice.textContent = '';
          comparePrice.style.display = 'none';
        }
      }


    };

    if (upsellVariantInput.tagName === 'SELECT') {
      upsellVariantInput.addEventListener('change', function () {
        const selectedOption = upsellVariantInput.options[upsellVariantInput.selectedIndex];
        const newImage = selectedOption.getAttribute('data-image');
        if (newImage && upsellImage && upsellImage.src !== newImage) {
          upsellImage.classList.add('fade-out');
          setTimeout(() => {
            upsellImage.src = newImage;
            upsellImage.classList.remove('fade-out');
          }, 150);
        }

        setTimeout(updateUpsellPrice, 100);
      });
    }

    form.querySelectorAll('[name="selling_plan"]').forEach(planInput => {
      planInput.addEventListener('change', () => {
        setTimeout(updateUpsellPrice, 100);
      });
    });

    if (shadowHost?.shadowRoot) {
      let rechargeTimeout;
      const rechargeObserver = new MutationObserver(() => {
        clearTimeout(rechargeTimeout);
        rechargeTimeout = setTimeout(updateUpsellPrice, 150);
      });

      rechargeObserver.observe(shadowHost.shadowRoot, {
        subtree: true,
        attributes: true,
        childList: true
      });
    }


    form.addEventListener('submit', function (e) {
      const upsellSelected = upsellCheckbox.checked;
      const upsellVariantId = upsellVariantInput.value;

      if (!upsellSelected || !upsellVariantId) return;

      e.preventDefault();

      setTimeout(() => {
        updateUpsellPrice();

        const upsellSellingPlanId = upsellSellingPlanInput?.value;
        const formData = new FormData(form);
        const mainProductData = new URLSearchParams(formData);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: mainProductData.toString()
        })
          .then(response => {
            if (!response.ok) throw new Error('Main product add failed');
            return response.json();
          })
          .then(() => {
            const upsellData = {
              id: upsellVariantId,
              quantity: 1
            };
            if (upsellSellingPlanId) {
              upsellData.selling_plan = upsellSellingPlanId;
            }


            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [upsellData] })
            });
          })
          .then(() => {
            fetch(`${routes.cart_url}?section_id=cart-drawer`)
              .then(response => response.text())
              .then(responseText => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                ['cart-drawer-items', '.cart-drawer__footer'].forEach(selector => {
                  const target = document.querySelector(selector);
                  const source = html.querySelector(selector);
                  if (target && source) target.replaceWith(source);
                });

                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                  cartDrawer.classList.add('is-open');
                  document.body.classList.add('overflow-hidden');
                }
              });
          })
          .catch(error => {
            console.error('[Upsell] Error:', error);
            alert('There was a problem adding your items to the cart.');
          });
      }, 100);
    });
  });
});



document.querySelector('.upsell-add-btn')?.addEventListener('click', () => {
  const select = document.querySelector('.upsell-variant-selector');
  const variantId = select?.value;

  if (!variantId) return;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1,
        selling_plan: getSelectedSellingPlanId() // Optional: if using subscriptions
      }]
    })
  })
  .then(res => res.json())
  .then(() => {
    // Optional: refresh cart drawer UI
    console.log('Upsell added!');
    // trigger cart re-render logic here if needed
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll(".lazy-video");

  wrappers.forEach(wrapper => {
    const src = wrapper.dataset.src;
    if (!src) return;

    // Setup IntersectionObserver so video loads only when visible
    const observer = new IntersectionObserver(entries => {
      if (!entries[0].isIntersecting) return;

      // Create autoplaying video
      const video = document.createElement("video");
      video.src = src;
      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.playsInline = true;

      video.addEventListener("loadeddata", () => {
        wrapper.classList.add("video-loaded"); // fade in
      });

      wrapper.appendChild(video);

      observer.disconnect();
    }, { threshold: 0.2 });

    observer.observe(wrapper);
  });
});
